module.exports = __webpack_public_path__ + "img/h1.8b6fa5fe.svg";